import { render } from "./pdf.vue?vue&type=template&id=2672a232&scoped=true"
import script from "./pdf.vue?vue&type=script&lang=js"
export * from "./pdf.vue?vue&type=script&lang=js"

import "./pdf.vue?vue&type=style&index=0&id=2672a232&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2672a232"]])

export default __exports__